<template>
  <div class="experience-box">
    <div class="experience-line-box">
      <div class="experience-line"></div>
      <div v-for="(item, index) in data" :key="index + 'experience-line-icon'" class="experience-line-icon-item">
        <img src="https://files.wondercv.com/pc/planning/index-step-icon.png" width="20" height="20"></img>
      </div>
    </div>
    <div style="padding-top: 90px">
      <template v-if="!isShowCarousel">
        <div class="experience-item" v-for="(item, index) in data" :key="index + 'experience-item'">
          <div class="flex-c">
            <div class="flex1">
              <p class="name">{{(item.type === 'school' ? item.university : item.company) || '该信息已隐藏'}}</p>
              <p class="post">{{(item.type === 'school' ? item.major : item.title) || '该信息已隐藏'}}</p>
            </div>
            <img  :src="item.type === 'school' ? (item.school && item.school.logo_url || 'https://files.wondercv.com/PC/editor/planning/campus.png') : 'https://files.wondercv.com/PC/editor/planning/company.png'" width="52" height="52"/>
          </div>
          <div class="flex time-box">
            <p>{{item.start_at ? item.start_at.substr(0, 7).replace(/\-/g,'.'): ''}}{{(item.end_at || item.present) && item.start_at ? '-' : ''}}{{item.end_at ? item.end_at.substr(0, 7).replace(/\-/g,'.') : (item.present ? item.present : '')}}</p>
            <p class="city-name">{{item.city}}</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="carousel-box" :style="{top: `${(data.length > 3 ? data.length - 3 : 0) * 207 + 90}px`}">
          <el-carousel direction="vertical" height="139px" indicator-position="none" :autoplay="false" :initial-index="(indicatorIndex) % data.length" @change="handleChangeIndex" ref="carousel">
            <el-carousel-item v-for="(item, index) in showData" :key="index + 'experience-item'">
              <div class="experience-item not" >
                <div class="flex-c">
                  <div class="flex1">
                    <p class="name">{{(item.type === 'school' ? item.university : item.company) || '该信息已隐藏'}}</p>
                    <p class="post">{{(item.type === 'school' ? item.major : item.title) || '该信息已隐藏'}}</p>
                  </div>
                  <img  :src="item.type === 'school' ? (item.school && item.school.logo_url || 'https://files.wondercv.com/PC/editor/planning/campus.png'): 'https://files.wondercv.com/PC/editor/planning/company.png'" width="52" height="52"/>
                </div>
                <div class="flex time-box">
                  <p>{{data.present}}{{item.start_at ? item.start_at.substr(0, 7).replace(/\-/g,'.'): ''}}{{(item.end_at || item.present) && item.start_at ? '-' : ''}}{{item.end_at ? item.end_at.substr(0, 7).replace(/\-/g,'.') : (item.present ? item.present : '')}}</p>
                  <p class="city-name">{{item.city}}</p>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="indicator-box">
            <i class="iconfont iconxiangshang" @click.stop="handleClickPrev"></i>
            <span>{{(indicatorIndex % data.length) + 1}}/{{data.length}}</span>
            <i class="iconfont iconxiangxia" @click.stop="handleClickNext"></i>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: "experience",
    props: {
      data: {
        type: Array,
        default: () => []
      }
    },
    data(){
      return {
        isShowCarousel: false,
        indicatorIndex: 0
      }
    },
    computed:{
      showData(){
        return this.data.reverse()
      }
    },
    methods:{
      animation(callback){
        //获取到经历的列表dom
        let itemList = document.querySelectorAll(".experience-item")

        //获取到轴线的dom
        let line = document.querySelector(".experience-line")

        //获取到轴线的dom
        let lineBox = document.querySelector(".experience-line-box")

        //获取到这个组建根dom
        let box = document.querySelector(".experience-box")

        //获取进度条icon的的列表
        let iconList = document.querySelectorAll(".experience-line-icon-item")

        line.style.transition = `height ${itemList.length * 0.5 + 0.25}s linear`;

        if(itemList.length > 3){

          box.style.transform = `translateY(-${(itemList.length - 3) * 207}px)`

          box.style.transition = `all ${(itemList.length - 3) * 0.5}s linear 1.5s`

        }

        Array.from(itemList).forEach((item, index) => {

          item.style.top = index * (139 + 68) + 90 + 'px'

          item.style.zIndex = index + 1

          item.style.transform = 'scale(1)';

          item.style.transition = `transform 0.5s linear ${index*0.5 + 0.4}s`

        })

        Array.from(iconList).forEach((item, index) => {

          item.style.opacity = '1';

          item.style.transition = `opacity 0s linear ${index*0.5 + 0.4}s`

        })

        line.className = 'experience-line max-height'

        line.addEventListener('transitionend', ()=>{
          setTimeout(()=>{
            lineBox.style.opacity = 0

            Array.from(itemList).forEach((item, index) => {

              item.style.transition = `top 0.5s linear 0s`

              item.style.top =  (((itemList.length - 3) < 0) ? 0 : (itemList.length - 3))* 207 + 90 + 'px'

            })

            box.style.transition = `left 0.7s linear 0.5s`

            box.style.left = `0px`
            box.addEventListener("transitionend",()=>{
              lineBox.style.display = 'none'
              callback && callback()
            })
          }, 1000)
        }, false)
      },
      handleEmitFunction(){
        if(this.isShowCarousel) return;
        this.$emit("show-recommend")
        this.isShowCarousel = true
      },
      handleChangeIndex(index){
        this.indicatorIndex = index
      },
      handleClickNext(){
        this.indicatorIndex = this.indicatorIndex + 1
        this.$refs.carousel.setActiveItem(this.indicatorIndex % this.data.length)
      },
      handleClickPrev(){
        this.indicatorIndex = this.indicatorIndex - 1
        this.$refs.carousel.setActiveItem(this.indicatorIndex % this.data.length)
      }
    },
    mounted() {
      let debounced = this._.debounce(this.handleEmitFunction, 710);
      setTimeout(()=>{
        this.animation(debounced)
      },0)
    }
  }
</script>

<style scoped lang="scss">
.experience-box{
  position: absolute;
  left:600px;
  top: -90px;
  z-index: 3;
  display: flex;
  .carousel-box{
    position: absolute;
    width: 375px;
    height: 139px;
    z-index: 3;
    .indicator-box{
      position: absolute;
      width: 24px;
      left: -43px;
      top: 50%;
      transform: translateY(-50%);
      list-style: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .iconfont{
        font-size: 24px;
        color: #606060;
        margin-bottom: 12px;
        cursor: pointer;
        &:hover{
          color: #CFCFCF;
        }
        &:last-child{
          margin-bottom: 0px;
        }
      }
      span{
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        line-height: 17px;
        margin-bottom: 12px;
      }
    }
  }
  .experience-line-box{
    width: 20px;
    height: 100%;
    position: relative;
    position: relative;
    box-sizing: border-box;
    left: -50px ;
    padding-top: 90px;
    .experience-line-icon-item{
      transform: translateY(-50%);
      margin-bottom: 187px;
      position: relative;
      z-index: 2;
      border-radius: 50%;
      box-shadow: 0px 0px 4px 0px #FFBA44;
      opacity: 0;
    }
    .experience-line{
      width: 2px;
      background: #FF8569;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1;
      top: 0;
      height: 0;
      &.max-height{
        height: calc(100% - 139px - 68px)
      }
    }
  }
  .experience-item{
    width: 375px;
    height: 139px;
    position: absolute;
    box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
    border-radius: 8px;
    background-image: url("https://files.wondercv.com/pc/planning/job-card-mini.png");
    background-size: 100%;
    box-sizing: border-box;
    padding: 20px 24px 14px;
    display: flex;
    flex-direction: column;
    margin-bottom: 68px;
    transform: scale(0);
    transform-origin:0 0;
    &.not{
      position: static;
      transform: scale(1);
      box-shadow: 0px 0px 0px 0px rgba(25, 28, 36, 0);
    }
    &:last-child{
      margin-bottom: 0;
    }
    img{
      border-radius: 5px;
      object-fit: cover;
    }
    .name{
      font-size: 20px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 28px;
      margin-bottom: 2px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      margin-right: 15px ;
    }
    .post{
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 22px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      margin-right: 15px ;
    }
    .time-box{
      margin-top: 16px;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      padding-top: 14px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      line-height: 22px;
      justify-content: space-between;
      .city-name{
        flex: 1;
        text-align: right;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        margin-left: 20px;
      }
    }
  }
}
</style>
